import React from "react";
import { ShieldCheck, Check } from "lucide-react";
import { GUARANTEE } from "@/data/brand";

export const GorillaGuarantee = ({ compact = false }) => {
  if (compact) {
    return (
      <div data-testid="gorilla-guarantee-compact" className="rounded-lg border border-navy/15 bg-cream p-5">
        <div className="flex items-center gap-2 text-navy font-display text-lg uppercase">
          <ShieldCheck className="w-5 h-5 text-brick" /> The Gorilla Guarantee
        </div>
        <ul className="mt-3 grid gap-1.5">
          {GUARANTEE.map((g) => (
            <li key={g} className="flex items-center gap-2 text-sm text-ink/80">
              <Check className="w-4 h-4 text-brick shrink-0" /> {g}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <section data-testid="gorilla-guarantee" className="bg-navy text-cream">
      <div className="jm-container py-16 grid gap-10 md:grid-cols-2 items-center">
        <div>
          <p className="uppercase tracking-[0.2em] text-gold font-bold text-sm">The Gorilla Guarantee</p>
          <h2 className="font-display text-4xl sm:text-5xl mt-3 leading-none">We stand behind every item.</h2>
          <p className="mt-4 text-cream/80 max-w-md leading-relaxed">
            Good items, good people, good vibes. Here's our promise on every single order.
          </p>
        </div>
        <ul className="grid sm:grid-cols-2 gap-3">
          {GUARANTEE.map((g) => (
            <li key={g} className="flex items-center gap-3 rounded-lg bg-white/10 border border-white/20 px-4 py-3">
              <ShieldCheck className="w-5 h-5 text-gold shrink-0" />
              <span className="font-semibold">{g}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
